import { useCallback } from "react"
import { useNavigate, useParams } from "react-router"
import { WaitingUploadPage } from "./WaitingUploadPage"
import { ConfirmLayout } from "@/templates/ConfirmLayout"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { useBackgroundFetchCtx } from "@/hooks/useBackgroundFetch"
import { useTranslation } from "@/hooks/useTranslation"

export const FinishPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { operationId } = useParams<"operationId">()
    assertIsDefined(operationId)
    const { inProgress } = useBackgroundFetchCtx()

    const gotoSchedule = useCallback(() => {
        navigate("/schedule")
    }, [navigate])

    if (inProgress) {
        return <WaitingUploadPage />
    }

    return (
        <ConfirmLayout
            title={t("報告は以上です！")}
            titleSecondLine={t("お疲れ様でした！")}
            sealImageSrc="/assets/azarashi/az_rfU_lfD_reF_leC.png"
            primaryButtonLabel={t("閉じる")}
            next={gotoSchedule}
        />
    )
}
